import { useNavigate } from 'react-router-dom'

// project imports
import { Views } from 'features/enumerations'
import useAuth from 'hooks/useAuth'
import { useEffect, useState } from 'react'
import { GuardProps } from 'types'

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const CustomerAdministratorGuard = ({ children }: GuardProps) => {
  const { isLoggedIn, claims } = useAuth()
  const [render, setRender] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    ;(function checkAuthorization(): any {
      if (
        isLoggedIn &&
        claims &&
        !claims?.player &&
        !claims?.customerAdministrator
      ) {
        navigate(`/${Views.Home}`, { replace: true })
      }
    })()
    setRender(isLoggedIn && claims?.customerAdministrator)
  }, [isLoggedIn, navigate, claims?.customerAdministrator])

  return children
}

export default CustomerAdministratorGuard
